import { BaseRepository } from './BaseRepository';
const queryString = require('query-string');

export class GoalRepository extends BaseRepository {
  public getGoalsOfOrganization(organizationId: string): Promise<any[]> {
    return this.httpClient
      .get(`/v2/organizations/${organizationId}/goals`, {
        params: { order: 'created_at_desc', lift_report: 1 },
      })
      .then((res: any) => res.data.data);
  }

  public getSelectedGoalIdFromUrl() {
    const query = queryString.parse(window.location.search);
    return query['goalId'] ? query['goalId'] : '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/repository/GoalRepository.ts